import React, { useState } from 'react';
import { uniq } from 'underscore';
import { Button, Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, Input, Label, } from '@cargomatic/ui';
import { Loader2 } from 'lucide-react';
import validator from 'email-validator';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
export default function SendEmailModal({ show, action, onSend, onHide }) {
    const [recipients, setRecipients] = useState('');
    const [error, setError] = useState('');
    const [enableSend, setEnableSend] = useState(false);
    const [sending, setSending] = useState(false);
    const { t } = useTranslation();
    const handleSend = async () => {
        try {
            const emails = recipients.replace(/' '/g, '').split(',');
            if (enableSend) {
                setSending(true);
                await onSend(uniq(emails));
                setSending(false);
                setRecipients('');
            }
        }
        catch (e) {
            setSending(false);
            throw e;
        }
    };
    const handleSetRecipients = (value) => {
        setRecipients(value);
        const emails = value.replace(/' '/g, '').split(',');
        const filtered = emails.filter(Boolean);
        const invalidEmailAddresses = filtered.filter((ea) => !validator.validate(ea));
        if (invalidEmailAddresses.length > 0) {
            setError(t('VALID_EMAIL_ONLY'));
            setEnableSend(false);
        }
        else {
            setError('');
            setEnableSend(filtered.length > 0);
        }
    };
    return (React.createElement(Dialog, { open: show, onOpenChange: (open) => !open && onHide() },
        React.createElement(DialogContent, { className: "max-w-md" },
            React.createElement(DialogHeader, null,
                React.createElement(DialogTitle, null, action)),
            React.createElement("div", { className: "space-y-4 py-4" },
                React.createElement("div", { className: "space-y-2" },
                    React.createElement(Label, { htmlFor: "recipients" }, titleize(t('RECIPIENT', { count: 2 }))),
                    React.createElement(Input, { id: "recipients", placeholder: t('COMMA_SEPARATED_EMAIL_ADDRESSES'), value: recipients, onChange: (e) => handleSetRecipients(e.target.value), className: error ? 'border-red-500' : '' }),
                    error && React.createElement("p", { className: "text-sm text-red-500" }, error))),
            React.createElement(DialogFooter, { className: "gap-2" },
                React.createElement(Button, { variant: "outline", onClick: onHide, disabled: sending }, t('CLOSE')),
                React.createElement(Button, { disabled: !enableSend || sending, onClick: handleSend }, sending ? (React.createElement(React.Fragment, null,
                    React.createElement(Loader2, { className: "mr-2 h-4 w-4 animate-spin" }),
                    t('SEND'))) : (t('SEND')))))));
}
